export const getPerfomanceTimings = () => {
    try {
        const performance = window.performance;
        return performance
            .getEntriesByType('paint')
            .reduce((acc, entry) => {
            acc[entry.name] = Math.round(entry.startTime);
            return acc;
        }, {});
    }
    catch (e) {
        return {};
    }
};
export const getNavTimings = () => {
    try {
        const { navigationStart, domInteractive, domComplete, domContentLoadedEventEnd } = window.performance.timing;
        return {
            domInteractive: domInteractive - navigationStart,
            domContentLoadedEventEnd: domContentLoadedEventEnd - navigationStart,
            domComplete: domComplete - navigationStart,
            providerInteractive: Date.now() - navigationStart
        };
    }
    catch (e) {
        return {};
    }
};
export const getProviderLoadTimings = (providerId, providerJsPath) => {
    var _a;
    const performanceTimings = {};
    try {
        // eslint-disable-next-line compat/compat
        const loadTiming = ((_a = window.performance.getEntriesByName(providerJsPath)[0]) !== null && _a !== void 0 ? _a : window.performance.getEntriesByName(`${providerJsPath}?1`)[0]);
        if (loadTiming) {
            performanceTimings.loadStart = Math.round(loadTiming.startTime);
            performanceTimings.loadEnd = Math.round(loadTiming.responseEnd);
        }
        // eslint-disable-next-line compat/compat
        const executionStartEntry = window.performance.getEntriesByName(`${providerId}_execution_start`)[0];
        if (executionStartEntry) {
            performanceTimings.executionStart = Math.round(executionStartEntry.startTime);
        }
        // eslint-disable-next-line compat/compat
        const executionEndEntry = window.performance.getEntriesByName(`${providerId}_execution_end`)[0];
        if (executionEndEntry) {
            performanceTimings.executionEnd = Math.round(executionEndEntry.startTime);
        }
        return performanceTimings;
    }
    catch (_b) {
        return performanceTimings;
    }
};
